import Enums, { OrderStatus } from "../../../types/enums";
import { Button, List, Tag, Text } from "../../../components";
import { Order } from "../../../types/item";
import { SVGs } from "../../../assets";
import { Tools } from "../../../utils";

interface Props {
  order: Order;
  onReorder?: () => void;
  onTrackOrder?: () => void;
  onViewInfo?: () => void;
}
const Item = ({
  order,
  onReorder = () => {},
  onViewInfo = () => {},
  onTrackOrder = () => {},
}: Props) => {
  const isCompleted = order.status === OrderStatus.completed;
  return (
    <List.Item
      onClick={() => {
        !isCompleted ? onTrackOrder() : onViewInfo();
      }}
      extra={
        <Button
          minWidth={"8.3rem"}
          title={isCompleted ? "Reorder" : "Track"}
          onClick={() => (!isCompleted ? onTrackOrder() : onReorder())}
        />
      }
    >
      <List.Item.Meta
        avatar={
          <img alt={order.uuid} style={{ width: "5rem" }} src={SVGs.fries} />
        }
        title={`Order #${order.orderNo || order.uuid}`}
        description={
          <>
            <Text
              weight={500}
              children={`${Tools.toCurrency(order.totals?.grandtotal ?? 0)}`}
            />
            <Text
              children={Tools.date(order.createdAt).format(
                "ddd, MMM D • h:mm A",
              )}
            />
            <Tag
              className="m-8-t"
              children={Enums.details(order.status)?.name}
              color={Enums.details(order.status)?.color}
            />
          </>
        }
      />
    </List.Item>
  );
};

export default Item;
